module.exports = "/fonts/feather.woff?3d2fa2e544004aef2ea641698b715af6";